"use client";

import { useId, useState } from "react";
import { Plus, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

export type FaqItem = { q: string; a: string };

/** Question list with one answer open at a time. Rules between rows, no boxes. */
export function Faq({ items, className, onDark = false }: { items: FaqItem[]; className?: string; onDark?: boolean }) {
  const [open, setOpen] = useState<number | null>(0);
  const base = useId();

  return (
    <div className={cn("border-t", onDark ? "border-line-dark" : "border-line", className)}>
      {items.map((item, i) => {
        const isOpen = open === i;
        const panelId = `${base}-p${i}`;
        const btnId = `${base}-b${i}`;
        return (
          <div key={i} className={cn("border-b", onDark ? "border-line-dark" : "border-line")}>
            <h3>
              <button
                id={btnId}
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                aria-controls={panelId}
                className={cn(
                  "flex w-full items-start justify-between gap-6 py-5 text-left text-[1.125rem] font-semibold leading-snug",
                  onDark ? "text-white" : "text-navy",
                )}
              >
                {item.q}
                {isOpen ? (
                  <Minus aria-hidden className="mt-1 h-4 w-4 shrink-0" />
                ) : (
                  <Plus aria-hidden className="mt-1 h-4 w-4 shrink-0" />
                )}
              </button>
            </h3>
            <div id={panelId} role="region" aria-labelledby={btnId} hidden={!isOpen}>
              <p className={cn("max-w-measure pb-6 text-body", onDark ? "text-mist" : "text-slate")}>{item.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
